import { useSubmitByEnter, useTriggerAction, selectSubmitWidget, useAppSelector } from '@libs/core';
import React from 'react';
import stylis from './pageWrapper.module.css';

export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
    const submitWidget = useAppSelector(selectSubmitWidget);
    const { triggerActionsByType } = useTriggerAction(submitWidget);
    const handleKeyDown = useSubmitByEnter(submitWidget, { triggerActionsByType });

    return (
        <div className={stylis.pageWrapper} onKeyDown={handleKeyDown}>
            {children}
        </div>
    );
};
